import React from 'react';
import { string } from '../../../localization';
import './TransparencyTool.scss';

export const TransparencyTool = props => {
  const { initialValue, setTransparencyValue } = props;
  return (
    <div
      className='undraggable custom-input-section transperancy-body'
      id='transparency-tool'
    >
      <div className='mt-3 form-group d-flex align-items-center'>
        0
        <input
          type='range'
          className='form-control-range scale-slider'
          min='0'
          step='0.01'
          max='1'
          onChange={e => setTransparencyValue(e, 'slider')}
          value={initialValue}
          id='formControlRange'
        />
        1
      </div>

      <div className='d-flex justify-content-center align-items-center mb-4 custom-input-box'>
        {string.ADJUST_TRANSPARENCY_KEY}
        <input
          className='form-control ml-1 mr-1'
          type='number'
          onChange={e => {
            setTransparencyValue(e, 'manual');
          }}
          value={initialValue}
        />
        %
      </div>
    </div>
  );
};
